import { buildTheme } from '../../shared/theme-builder';
import afcpe from './index';
import micro from './micro';

export const fullTheme = buildTheme(afcpe.theme, afcpe.variants);
export const microTheme = buildTheme(micro.theme, micro.variants);
export default fullTheme;
